import { useQuery } from "@apollo/client";
import { GridInputs } from "../../../../../components/Functional";
import { FETCH_CONTACT_ADDRESS_TYPE } from "../../../../../graphql/query/ContactAddressType";

const getContactDetailInputs = ({
  countryOptions,
  contactAddressTypes,
} = {}) => ({
  className: "grid grid-cols-4 gap-4",
  inputs: [
    {
      className: "gap-4",
      inputs: [
        {
          className: "grid-cols-1",
          inputs: [
            {
              label: "Mailing Label Name",
              name: "mailingname",
              type: "text",
            },
          ],
        },
        {
          className: "p-4 border rounded gap-4",
          inputs: [
            {
              hasOperator: true,
              label: "Email",
              name: "email",
              type: "text",
            },
          ],
        },
      ],
    },
    {
      className: "col-span-3 gap-4",
      inputs: [
        {
          className: "grid-flow-col grid-col-3 gap-4",
          inputs: [
            { label: "Salutation", name: "salutation", type: "text" },
            { label: "Other contact details", name: "notes", type: "text" },
          ],
        },
        {
          className: "grid-flow-col grid-col-3 p-4 border rounded gap-4",
          inputs: [
            {
              className: "col-span-1 gap-4",
              inputs: [
                {
                  label: "Address Type",
                  name: "_contactAddress.typeId",
                  options: contactAddressTypes?.map(item => ({
                    label: item?.description,
                    value: item?.id,
                  })),
                  type: "multi-select",
                },
                {
                  label: "Country",
                  name: "_contactAddress.countryId",
                  options: countryOptions,
                  type: "multi-select",
                },
              ],
            },
            {
              inputs: [
                { label: "Town", name: "_contactAddress.town", type: "text" },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const ContactDetails = props => {
  const { countryOptions, formik } = props || {};

  const { data: { contactAddressTypes = [] } = {} } = useQuery(
    FETCH_CONTACT_ADDRESS_TYPE,
  );

  const inputs = getContactDetailInputs({
    countryOptions,
    contactAddressTypes,
  });

  return <GridInputs formik={formik} {...inputs} />;
};

export default ContactDetails;
export { getContactDetailInputs };
